import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Avatar, CardHeader } from '@material-ui/core';
import moment from 'moment';
import { useStyles } from './style';
import { APPOINTMENT_DETAILS, APPOINTMENTS } from '../../utils/urls';
import { useHistory } from 'react-router-dom';

function AppointmentCard({
  theme,
  appointment,
  isProfessional,
  session,
  getNewAccessToken,
  userState,
  appointmentData,
  getMpPreference,
}) {
  const styles = useStyles();
  const history = useHistory();
  const [actualDate, setActualDate] = useState(moment());

  const handlePayment = () => {
    const body = {
      title: `Appointment`,
      price: appointment.price,
      appointment: appointment.id,
    };
    getMpPreference(body);
  };

  useEffect(() => {
    // When appointment is deleted
    appointmentData.success.genericMessage ==
      'Appointment eliminado con exito' && history.push(APPOINTMENTS);
  }, [appointmentData.success]);
  // useEffect(() => {
  //   if (userState?.mpPreference?.auto_return == 'approved') {
  //     window.location.replace(userState.mpPreference.init_point);
  //   }
  // }, [userState?.mpPreference]);

  const handleSeeAppointment = () => {
    history.push({
      pathname: APPOINTMENT_DETAILS,
      state: {
        appointment,
      },
    });
  };

  useEffect(() => {
    let secTimer = setInterval(() => {
      setActualDate(moment());
    }, 5000); //every five seconds we get the actual Date time to update "IR"

    return () => clearInterval(secTimer);
  }, []);

  // useEffect(() => {
  //   if (userState.success == 'Nuevo token obtenido con éxito') {
  //     let pageName =
  //       process.env.REACT_APP_VIDEO_URL +
  //       'appointment/' +
  //       appointment.id +
  //       '/?idUser=' +
  //       session.id +
  //       '&token=' +
  //       session.accessToken;
  //     window.open(pageName);
  //   }
  // }, [userState.success]);

  if (isProfessional && !appointment.is_payed) {
    return null;
  }

  return (
    <>
      <Paper
        style={{
          borderTop: `2px solid ${theme.palette.primary.main}`,
          width: 300,
          padding: '1.5rem',
          margin: '0.5rem',
        }}
      >
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          flexWrap='wrap'
        >
          <span>
            {'Consulta: '}
            <span style={{ fontWeight: 'bold' }}>{` ${moment(appointment.date)
              .tz(moment.tz.guess())
              .format('YYYY-MM-DD HH:mm [hs]')}`}</span>
          </span>
        </Box>
        <Box>
          <CardHeader
            style={{ paddingLeft: '0px' }}
            avatar={
              <Avatar
                alt='Foto de perfil'
                src={
                  isProfessional
                    ? appointment.patient?.profile_picture
                      ? appointment.patient?.profile_picture?.url
                      : null
                    : appointment.doctor?.profile_picture
                    ? appointment.doctor?.profile_picture?.url
                    : null
                }
                style={{
                  height: '60px',
                  width: '60px',
                }}
                className={styles.avatar}
              />
            }
            title={`${
              appointment.patient
                ? `${
                    isProfessional
                      ? appointment.patient.full_name
                      : appointment.doctor.full_name
                  }`
                : 'Patient'
            }`}
            subheader={
              isProfessional ? (
                <div>
                  <span style={{ fontWeight: 'bold' }}>
                    {appointment.patient?.identity_document
                      ? `CI: ${appointment.patient.identity_document}`
                      : 'Patient null'}
                  </span>
                  <br></br>{' '}
                  <span>
                    {appointment.patient
                      ? `Nacimiento: ${appointment.patient.date_of_birth}`
                      : 'Patient null'}
                  </span>
                </div>
              ) : (
                <div>{appointment.doctor.specialty.name}</div>
              )
            }
          />
        </Box>
        <Box marginTop='1rem'>
          <span style={{ fontWeight: 300 }}>Motivo de la consulta: </span>
        </Box>
        <Box>
          <span style={{ fontWeight: 'bold' }}>
            {appointment.patient
              ? appointment.patient_appointment_reason
              : 'Null'}
          </span>
        </Box>

        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexWrap='wrap'
          style={{ margin: '10px' }}
        >
          <Button
            color='primary'
            variant='contained'
            style={{ marginRight: '2rem' }}
            //disabled={moment(appointment.date).diff(actualDate, 'minutes') > 5}
            onClick={handleSeeAppointment}
          >
            Ver
          </Button>

          {appointment.is_payed && (
            <Button
              color='primary'
              variant='contained'
              //disabled={moment(appointment.date).diff(actualDate, 'minutes') > 5}
              onClick={() => {
                let pageName =
                  process.env.REACT_APP_VIDEO_URL +
                  'appointment/' +
                  appointment.id +
                  '/?idUser=' +
                  session.id +
                  '&token=' +
                  session.accessToken +
                  '&light=1';
                window.location.href = pageName;
              }}
            >
              IR
            </Button>
          )}
          {!appointment.is_payed && (
            <Button
              variant='contained'
              style={{
                backgroundColor: '#4BB543',
                color: 'white',
              }}
              onClick={handlePayment}
            >
              Pagar
            </Button>
          )}
        </Box>
      </Paper>
    </>
  );
}

export default AppointmentCard;
